export enum ELogsActionsTypes {
	IMPORT_FILE = 'IMPORT_FILE',
	EXPORT_FILE = 'EXPORT_FILE',
	EXPORT_FILE_FAILED = 'EXPORT_FILE_FAILED',
}

export enum EExportOutputType {
	DATA = 'DATA',
	ORIGINAL_FILE = 'ORIGINAL_FILE',
}

export enum EExportTriggerSource {
	AUTO = 'AUTO',
	MANUAL = 'MANUAL',
	API = 'API',
}

export enum EExportTarget {
	FTP = 'FTP',
	DOWNLOAD = 'DOWNLOAD',
	ERP = 'ERP',
}

export type LogsListItem = {
	_id: string;
	companyId?: string;
	userId?: string;
	fileId?: string;
	actionType: ELogsActionsTypes;
	fileName?: string;
	outcome?: string;
	errorMessage?: string;
	attempt?: number;
	isTerminal?: boolean;
	outputType?: EExportOutputType;
	exportTrigger?: EExportTriggerSource;
	exportTarget?: EExportTarget;
	exportFormat?: string;
	exportedFileName?: string;
	destinationPath?: string;
	customModelId?: string;
	generativeModelId?: string;
	createdAt: string;
};

export type LogsListRes = {
	results: LogsListItem[];
	totalCount: number;
	page: number;
	perPage: number;
};

export type LogsPaginationReq = {
	page?: number;
	perPage?: number;
	sort?: 'ASC' | 'DESC';
	search?: string;
};

export type ExportErrorsReq = LogsPaginationReq & {
	from?: string;
	to?: string;
};

export type ExportErrorsReportReq = {
	from?: string;
	to?: string;
};
